import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { map, switchMap } from "rxjs/operators";
import * as type from './actionTypes';
import * as ContractChangeRequestAction from './actions';
import { ContractChangeRequestService } from "./service";
import { IServerResponse } from "app/interface";

@Injectable()
export class ContractChangeRequestEffect {

    constructor(
        private action: Actions,
        private contractChangeRequestService: ContractChangeRequestService
    ) { }

    GetRequestList = createEffect(() => this.action.pipe(
        ofType(type.GET_REQUEST_LIST),
        switchMap(() => this.contractChangeRequestService.getRequestList()),
        map((data: Array<any>) => new ContractChangeRequestAction.SetRequestList(data))
    ));

    RequestById = createEffect(() => this.action.pipe(
        ofType(type.SEARCH_REQUEST_BY_ID),
        switchMap((data: any) => this.contractChangeRequestService.getRequestById(data.payload)),
        map((data: Array<any>) => new ContractChangeRequestAction.SetRequestById(data))
    ));

    SearchRequestByFields = createEffect(() => this.action.pipe(
        ofType(type.SEARCH_REQUEST_BY_FIELD),
        switchMap((data: any) => this.contractChangeRequestService.searchRequestByFields(data.payload)),
        map((data: any) => new ContractChangeRequestAction.RequestByFieldList(data)
        )
    ));

    AddRequest = createEffect(() => this.action.pipe(
        ofType(type.ADD_REQUEST),
        switchMap((data: any) => this.contractChangeRequestService.addRequest(data.payload)),
        map((data: IServerResponse) => new ContractChangeRequestAction.AddRequestResponse(data))
    ));

    UpdateRequest = createEffect(() => this.action.pipe(
        ofType(type.UPDATE_REQUEST),
        switchMap((data: any) => this.contractChangeRequestService.updateRequest(data.payload)),
        map((data: IServerResponse) => new ContractChangeRequestAction.UpdateRequestResponse(data))
    ));

    DeleteRequest = createEffect(() => this.action.pipe(
        ofType(type.DELETE_REQUEST),
        switchMap((data: any) => this.contractChangeRequestService.deleteRequest(data.payload)),
        map((data: IServerResponse) => new ContractChangeRequestAction.DeleteRequestResponse(data))
    ));

    ApproveRejectRequest = createEffect(() => this.action.pipe(
        ofType(type.APPROVE_REJECT_REQUEST),
        switchMap((data: any) => this.contractChangeRequestService.approveRejectRequest(data.payload)),
        map((data: IServerResponse) => new ContractChangeRequestAction.ApproveRejectRequestResponse(data))
    ));
}
